module.exports = __webpack_public_path__ + "static/sefastone-detail3-565036022496b6ebf290efea23b7077c.png";